import { Component, Host, Prop, h, State, Element, Method, Listen, Watch } from '@stencil/core';
import Plyr from 'plyr';
import { jitsuClient } from '@jitsu/sdk-js';
// import posthog from 'posthog-js'
// if (!window.location.host.includes('127.0.0.1') && !window.location.host.includes('localhost')) {
//   posthog.init('phc_PFn3ipf7jR88MXFX73PMM6l7A0G5EeZf0llC0u5FVKv', { api_host: 'https://app.posthog.com', autocapture: false, capture_pageview: false})
// }
const jitsu = jitsuClient({
    key: "js.ku52f0vferwtf16hunn8p6.s4zhwpli8w7pwz9k0y1kc",
    tracking_host: "https://t.jitsu.com"
});
@Component({
  tag: 'as-player',
  styleUrl: 'as-player.css',
  shadow: true,
  assetsDirs: ['icons']
})

export class AsPlayer {
  @Element() el: HTMLElement;
  @Prop({ attribute: 'vid' }) videoId: string;
  @Prop() fvideo?: any;
  @Prop({ attribute: 'cid' }) channelId?: string = null;
  @Prop({ attribute: 'pid' }) playlistId?: string = null;
  @Prop() env?: string = '';
  @Prop() showheader?: boolean = true;
  @Prop() showheadertitle?: boolean = true;
  @Prop() showfooterplay?: boolean = false;
  @Prop() showfootertitle?: boolean = false;
  @Prop() showproductchip?: boolean = false;
  @Prop() showproductcard?: boolean = false;
  @Prop({ mutable: true }) w?: string = null;
  @Prop({ mutable: true }) h?: string = null;
  @Prop({ mutable: true }) sw?: number;
  @Prop({ mutable: true }) sh?: number;
  @Prop() autoplay?: boolean = false;
  @Prop() loop?: boolean = true;
  @Prop() fullscreen?: boolean = false;
  @Prop() playclick?: any;
  @Prop() mode?: string = 'story';
  @Prop() position?: string = 'br'; // br tl tr bl - b(bottom), t(top), l(left), r(right)
  // @Prop() margin?: string = '8px'; // margin
  @Prop() piphandler?: any = null;
  @Prop() platform?: any = 'web';
  @Prop({ mutable: true }) widget?: any = 'storyblok';
  @Prop({ mutable: true }) shopify?: boolean = false;
  @Prop() tk: boolean = true;
  @Prop() placeholder?: boolean = true;
  @Prop() productoverlay?: any = null;
  @Prop({ mutable: true }) forcemute?: boolean = null;
  @Prop() mutehandler?: any = null;
  @Prop() index?: number = null;
  @Prop() size?: string = 'default';
  @Prop() ch?: number = 320;
  @Prop() preload?: boolean = false;


  @State() video: any = null;
  @State() isMute: boolean = true;
  @State() isPlaying: boolean = false;
  @State() videoUrl: string;
  @State() hiddenControls: boolean = false;
  @State() hidden: boolean = false;
  @State() handlerPipMode?: boolean = false;
  @State() addedToCart?: boolean = false;
  @State() addToCartLoading: boolean = false;
  @State() loopCount: number = 0;
  @State() loading: boolean = true;
  @State() playerready: boolean = false;
  @State() cover: boolean = true;
  @State() playsuspend: boolean = false;

  // videoEl!: HTMLVideoElement;


  private player!: any;
  private enterPipClick: any;
  private closePipClick: any;
  private backdropClick: any;
  private shopifyProduct: any = null;
  private shopifyVariantId: any = null;
  private shopifyQty: any = 1;
  private playingTime: any = 0;
  private startTime: any = 0;
  private playControlClick: any;
  private openFullScreen: any;
  private closeFullScreen: any;
  private plyrloaded: boolean = false;
  private pload: string = 'metadata';

  // private iosSafari: boolean = false;

  @Method()
  async load() {
    if(this.loading) {
      setTimeout(this.load, 100);
    }
    else if(!this.plyrloaded) {
      try {
        this.setupPlyr();
      } catch(e) {
        setTimeout(this.load, 200);
      }
    }
  }

  @Method() 
  async closeoverlay() {
    const overlay = this.productoverlay ? this.productoverlay : this.el.shadowRoot.querySelector('as-product-overlay');
    overlay?.close(false);
  }
  
  @Method()
  async play() {
    // show a prompt
  //  console.log(`play triggered ${this.video.title}`, this.player.playing, this.isPlaying, this.playerready, this.loading);
  if(!this.plyrloaded) {
    this.setupPlyr();
    setTimeout(() => this.play(), 100);
  } else {
    try {
      if(!this.loading && this.playerready) {
        if(!this.player?.playing && !this.isPlaying) {
          // const overlay = this.productoverlay ? this.productoverlay : this.el.shadowRoot.querySelector('as-product-overlay');
          // overlay?.close();
         
          this.player.play().catch((error) => {
            console.log(error.name);
           if(error.name === 'NotAllowedError') {
             this.playsuspend = true;
           } else {
            this.muted(true);
            if(!this.playsuspend) {
              setTimeout(() => this.play(), 100);
              this.playsuspend = true;
            }
           }
            // alert(error);
          });
          this.isPlaying = true;
        }

        // else {
          if(!this.playsuspend) {
            setTimeout(()=> {
              this.isPlaying = this.player?.playing;
                if(!this.isPlaying) {
                  const vel: any = this.el.shadowRoot.querySelector('video');
                  const velplaying = !!(vel.currentTime > 0 && !vel.paused && !vel.ended && vel.readyState > 2);
                  this.isPlaying = velplaying;
                  // console.log('vel playing', vel, velplaying);
                  if(!this.isPlaying){
                    // this.player.destroy();
                    // this.setupPlyr();
                    this.play();
                  }
                    // 
                }
              }, 100);
          } else {
            // this.isPlaying = false;
            this.player.playing = false;
          }
        // }
      } else {
        setTimeout(() => this.play(), 200);
      }
    } catch(e) {
      // console.log('play error', e);
      this.isMute = true;
      if(this.player) {
        this.player.muted = true;
        this.play(); 
      } else {
        setTimeout(() => this.play(), 200);
      }
    }
    }
  }

  @Method()
  async pause() {
    // show a prompt
    // console.log(`pause triggered ${this.video.title}`, this.player.playing, this.isPlaying);

    if(!this.player) {
      setTimeout(()=> this.pause(), 100);
    } else {
      if(this.isPlaying || this.player?.playing) {
        this.player?.pause();
        // alert('pause');
        this.isPlaying = false;
      } 
      const vel: any = this.el.shadowRoot.querySelector('video');
      const velplaying = !!(vel.currentTime > 0 && !vel.paused && !vel.ended && vel.readyState > 2);
      if(this.player?.playing || velplaying) {
        vel.pause();
      }
    }
  }

  @Method()
  async muted(t) {
    // show a prompt
    // console.log('muted', t);
    if(this.playerready && this.player) {
      this.isMute = t;
      this.player.muted = t;
    } else {
      setTimeout(() => this.muted(t), 200);
    }
  }

  @Method()
  async viewFullScreen() {
    this.openFullScreen();
  }

  // @Listen('load', { target: 'window' })
  // async onPageLoad() {
  //   if(this.mode === 'pinned' || this.widget === 'storyblok' || this.preload) {
  //     // console.log('plyr loaded', this.plyrloaded);
  //     setTimeout(() => this.load(), 100);
  //   }
  // }

  @Listen('resize', { target: 'window', passive: true })
  async windowResize() {
    // show a prompt
    var s = this;
    const vidEl = this.el.shadowRoot.querySelector('.as-player-wrapper');
    this.resetHeight(vidEl, s);
  }

  @Listen('beforeunload', { target: 'window', passive: true })
  async pageExit() {
    // show a prompt
    if(this.video) {
      this.trackEvent("end_watch_video", {
        category: this.getPlayerCategory(),
        loop_count: this.loopCount,
        playing_time: this.playingTime,
        watch_time: Math.min(10,this.loopCount)*this.video.duration + this.playingTime,
        mute: this.isMute,
        ...this.getCtaAttributes(this),
      });
    }
    return true;
  }

  @Listen('blur', { target: 'window', passive: true })
  async pageBlur() {
    // show a prompt
    if(this.video && (this.widget === 'storyblok' || this.widget === 'floating_player') && !this.hidden) {
      // this.pause();
      // this.pause();
      // if (this.widget !== 'carousel_player' && this.widget !== 'carousel_player_fullscreen') {
      //   this.trackEvent("page_blur", {
      //     category: this.getPlayerCategory(),
      //     loop_count: this.loopCount,
      //     playing_time: this.playingTime,
      //     mute: this.isMute,
      //     ...this.getCtaAttributes(this),
      //   });
      // }
    }
  }

  @Listen('focus', { target: 'window', passive: true })
  async pageFocus() {
    // show a prompt
    if(this.video && (this.widget === 'storyblok' || this.widget === 'floating_player') && !this.hidden) {
      if(this.autoplay || this.mode === 'pinned') {
        // this.play();
      }
      // if(this.autoplay || this.mode === 'pinned') {
      //   this.play();
      // }
      // if (this.widget !== 'carousel_player' && this.widget !== 'carousel_player_fullscreen') {
      //   this.trackEvent("page_focus", {
      //     category: this.getPlayerCategory(),
      //     loop_count: this.loopCount,
      //     playing_time: this.playingTime,
      //     mute: this.isMute,
      //     ...this.getCtaAttributes(this),
      //   });
      // }
    }
  }

  @Watch('loading')
  watchStateHandler(newValue: boolean) {
    if(!newValue) {
      // setTimeout(() => this.setupPlyr(), 25);
    }
  }

  componentWillLoad() {
    if(this.size === 'mini') {
      this.ch = 180;
      var style = document.createElement( 'style' )
      style.innerHTML = `:root { --asplayer-ch: ${this.ch}px; }`;
      if(this.ch <= 210) {
        style.innerHTML = `${style.innerHTML}  @media (min-width: 768px) { :root { --asplayer-ch: ${this.ch*1.5}px; } }`;
      }
      document.body.appendChild( style );
    }
    if(this.mode === 'pinned') {
      this.enablePip();
      if(this.widget === 'storyblok') {
        this.widget = 'floating_player';
      }
    }

    if(this.piphandler) {
      // console.log('handler pip mode fls', this.fullscreen);
      this.handlerPipMode = true;
    }

    if(this.forcemute) {
      this.isMute = true;
    }
  }

  async componentDidLoad() {

    // var ua = window.navigator.userAgent;
    // var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    // var webkit = !!ua.match(/WebKit/i);
    // this.iosSafari = iOS && webkit && !ua.match(/CriOS/i);

    var s: any = window;

    // var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    // if(isSafari) {
    //   this.pload = 'auto';
    // }

    // console.log('given w h', this.w, this.h);

    if(this.video || this.placeholder) {
      if(!this.sw) {
        this.sw = this.el.getBoundingClientRect().width;
        this.sh = this.el.getBoundingClientRect().height;
        if(this.h) {
          this.sh = parseInt(this.h.replace('px', ''));
        }
      }
      const vidEl = this.el.shadowRoot.querySelector('.as-player-wrapper');
      const st = this;
      this.resetHeight(vidEl, st);
    }

    let finalvideo = null;

    if(this.fvideo) {
      finalvideo = this.fvideo;
      this.videoUrl = this.getVideoUrl(finalvideo);
    }

    if(s?.Shopify && this.platform === 'shopify') {
      this.shopify = true;
      if(this.mode === 'pinned' && !this.videoId) {
        const sp = await this.onShopifyProductPage();
        if(!sp) {
          // console.log('not product page - player wont load');
          return false;
        }
      }
      // console.log('shopify product', this.shopifyProduct);
    }

    // console.log('video', this.video.id);
    if(!finalvideo) {
      let cheader = {
        "Content-type": "application/json;charset=UTF-8",
      };

      if(this.channelId) {
        cheader["channel_id"] = this.channelId;
      }
      let vUrl = `${this.getApiUrl(this.env)}/web/videos/`;
      if(this.videoId) {
        vUrl = `${vUrl}${this.videoId}`;
      } else if(this.platform === 'shopify' && this.shopifyProduct?.product?.id) {
        vUrl = `${vUrl}product-video?productId=${this.shopifyProduct?.product?.id}&platform=shopify`;
      } else {
        // console.log('no api to fetch from');
        return false;
      }

      const vidResponse = await fetch(vUrl,
      {
        method: "GET",
        headers: cheader,
      });
      if(vidResponse.status === 200) {
        const vidData = await vidResponse.json();
        finalvideo = vidData;
        this.videoUrl = this.getVideoUrl(finalvideo);
      } else {
        return false;
      }
    }

    // console.log('final video', finalvideo);

    this.setVideo(finalvideo);

    if(this.video?.channel?.primaryColor?.hex) {
      var style = document.createElement( 'style' )
      style.innerHTML = `.photoWrapper { --as-player-btn-color: ${this.video.channel.primaryColor.hex}; --as-player-btn-txt-color: ${this.video.channel.textColor.hex}; }`;
      this.el.shadowRoot.appendChild( style );
    }

    if(this.tk && this.video) {
      this.setJitsu(this);
    }
    return true;
  }

  render() {

      return (
        <Host>
          {this.mode === 'pinned' && <div 
          class={{ backdrop: (this.mode === 'pinned'), 
          fullscreen: this.fullscreen 
          }} onClick={this.backdropClick}></div>}
          <div class={{ playerWrapper: true,
          'as-player-wrapper': true,
          'cover': this.cover,
          'pinned': (this.mode === 'pinned' && !this.fullscreen),
          'fullscreen': ((this.fullscreen || this.widget==='carousel_player_fullscreen') && this.widget !== 'reels_player_fullscreen'),
          'reels': (this.widget === 'reels_player_fullscreen'),
          'br': (this.position === 'br'),
          'bl': (this.position === 'bl'),
          'tr': (this.position === 'tr'),
          'tl': (this.position === 'tl'),
          'hidden': (this.hidden),
          'show': this.videoUrl ? true : false,
          'sizemini': (this.size === 'mini'),
          }} 
          style={{ width: `${this.w && !this.fullscreen ? this.w : '100%'}`, height: `${this.h ? this.h : (this.fullscreen || this.sw<576 ? '100%' : '75vh')}` }}
          >

        {(!this.video) && this.mode !== 'pinned' && (
                  <div class="cards">
                  <div class="card_image loading"></div>
                  {/* <div class="card_description loading"></div> */}
                </div>
                )}
        
        <div style={{ height: '100%', position: 'relative', background: '#000'}} id={`as-player-${this.video?.id || Date.now()*Math.random()}`}>

        {!this.productoverlay && <as-product-overlay trackevent={this.trackEvent} env={this.env}></as-product-overlay>}

          {this.videoUrl && <video preload={this.pload} class="lazy player lozad"  playsinline id="player"
          data-poster={this.video?.posterUrls?.['576'] || "https://cdnv2.allstudio.live/video-poster-placeholder.png"}
          data-src={this.videoUrl}
          style={{ width: `${this.w && !this.fullscreen ? this.w : '100%'}`, height: `${this.h ? this.h : (this.fullscreen || this.sw<576 ? '100vh' : '75vh')}` }}
          >
            {this.videoUrl && <source data-src={this.videoUrl} type="video/mp4" />}
          </video>}

          {(this.mode !== 'pinned') && ((!this.isPlaying && this.playerready && !this.fullscreen)) && (
          <div class="cards fullheight z2">
            <img src={this.video?.posterUrls?.['576'] || "https://cdnv2.allstudio.live/video-poster-placeholder.png"} />
            <div class="playanimation" onClick={this.playControlClick}>

              <svg class="icon" role="presentation" width={this.size === 'mini' ? 20 : 24} viewBox="0 0 24 24"><use xlinkHref="#as-play"></use></svg>
    
            </div>
          </div>)}

          {this.isPlaying && (this.widget === 'carousel_player' || this.widget === 'grid_player') && (
            <div class="fullheight z2">
            <div class="playanimation" onClick={this.playControlClick}>

              <svg class="icon" role="presentation" width={this.size === 'mini' ? 20 : 24} viewBox="0 0 24 24"><use xlinkHref="#as-play"></use></svg>
    
            </div>
          </div>
          )}

          {this.video && <div class="flexWrapper" style={{ height: `calc(${this.h} - ${this.mode === 'pinned' && !this.fullscreen ? '56px' : '104px'})` }}>
            <main class="vmWrapper" onClick={this.playControlClick}>
            </main>

          {!this.showfootertitle && this.showheadertitle && this.video.shoppableType === 'cta' 
              && this.video.shoppableData?.ctaLink !== '' && (
                <footer class="ctaLinkContainer">
                  <a class={{
                    ctaLink: true,
                    large: (this.video.channel.ctaButtonSize === 'large'),
                    small: (this.video.channel.ctaButtonSize === 'small'),
                  }} style={{
                    "color": `${this.video.channel.textColor.hex}`,
                    "background-color": `${this.video.channel.primaryColor.hex}`,
                  }} href={this.video.shoppableData?.ctaLink} title={this.video.shoppableData?.ctaType} >{this.video.shoppableData?.ctaType}</a>
                </footer>
              )}

            {!this.showfootertitle && this.showheadertitle && this.platform === 'shopify' && this.video.shoppableType === 'addtocart' 
              && this.shopifyVariantId && (
                <footer class="ctaLinkContainer">
                  {this.addedToCart ? <div class="toastMessage">Item added to cart.</div> :
                  <a class={{
                    ctaLink: true,
                    large: (this.video.channel.ctaButtonSize === 'large'),
                    small: (this.video.channel.ctaButtonSize === 'small'),
                  }} style={{
                    "color": `${this.video.channel.textColor.hex}`,
                    "background-color": `${this.video.channel.primaryColor.hex}`
                  }} onClick={async (e) => { 
                    e.preventDefault(); 
                    if(!this.addToCartLoading) 
                      await this.addShopifyItem();
                  }} 
                  title={this.video.shoppableData?.ctaType}>{this.addToCartLoading ? (<div class="lds-ring"><div></div><div></div><div></div><div></div></div>) : this.video.shoppableData?.ctaType}</a>}
                </footer>
              )}

              {this.showproductchip && this.video.shoppableData?.products && !this.loading && this.playclick ? (
                <footer class="ctaLinkContainer">
                            <as-product-chip size={this.size} onClick={this.playControlClick} products={this.video.shoppableData?.products} trackevent={this.trackEvent}></as-product-chip>
                            </footer>
                          ):(<span></span>)}

              {this.showproductcard && this.video.shoppableData?.products && !this.loading ? (
                <footer class="ctaLinkContainer no-padding">
                            <as-product-card-slider 
                            products={this.video.shoppableData?.products}
                            overlay={this.productoverlay ? this.productoverlay : this.el.shadowRoot.querySelector('as-product-overlay')}
                            channel={this.video.channel} trackevent={this.trackEvent} player={this}
                            ></as-product-card-slider>
                            </footer>
                          ):(<span></span>)}
            </div>}

      </div>
      </div>

      <div hidden><svg>
<defs>
<g id="as-airplay">
<path d="M28.444 1.778h-24.889c-0.983 0-1.778 0.795-1.778 1.778v17.778c0 0.983 0.795 1.778 1.778 1.778h5.333v-3.556h-3.556v-14.222h21.333v14.222h-3.556v3.556h5.333c0.983 0 1.778-0.795 1.778-1.778v-17.778c0-0.983-0.795-1.778-1.778-1.778v0z"></path>
<path d="M7.111 30.222h17.778l-8.889-10.667z"></path>
</g>
<g id="as-enter-fullscreen">
<path d="M17.778 5.333h6.4l-7.111 7.111 2.489 2.489 7.111-7.111v6.4h3.556v-12.444h-12.444z"></path>
<path d="M12.444 17.067l-7.111 7.111v-6.4h-3.556v12.444h12.444v-3.556h-6.4l7.111-7.111z"></path>
</g>
<g id="as-exit-fullscreen">
<path d="M1.778 21.333h6.4l-7.111 7.111 2.489 2.489 7.111-7.111v6.4h3.556v-12.444h-12.444z"></path>
<path d="M28.444 1.067l-7.111 7.111v-6.4h-3.556v12.444h12.444v-3.556h-6.4l7.111-7.111z"></path>
</g>
<g id="as-fast-forward">
<path d="M14 12.749l-14-10.971v28.444l14-10.971v10.971l18-14.222-18-14.222z"></path>
</g>
<g id="as-logo-vimeo">
<path d="M30.222 9.422c-0.178 2.844-2.133 6.578-5.867 11.378-3.911 4.978-7.111 7.467-9.778 7.467-1.6 0-3.022-1.6-4.267-4.622-1.422-4.267-2.489-12.978-4.978-12.978-0.178 0-0.889 0.533-2.133 1.422l-1.422-1.778c1.422-1.244 6.222-6.044 8.356-6.222s3.556 1.244 4.089 4.444c0.533 3.556 1.422 10.844 3.2 10.844 1.6 0 4.444-6.044 4.622-7.111 0.178-1.6-0.533-3.378-4.089-1.956 1.422-4.622 4.089-6.756 8-6.756 3.022 0.178 4.444 2.133 4.267 5.867z"></path>
</g>
<g id="as-logo-youtube">
<path d="M29.867 10.311c-0.356-2.311-1.422-3.911-3.911-4.267-3.911-0.711-9.956-0.711-9.956-0.711s-6.044 0-9.956 0.711c-2.489 0.356-3.733 1.956-3.911 4.267-0.356 2.311-0.356 5.689-0.356 5.689s0 3.378 0.356 5.689c0.356 2.311 1.422 3.911 3.911 4.267 3.911 0.711 9.956 0.711 9.956 0.711s6.044 0 9.956-0.711c2.489-0.533 3.556-1.956 3.911-4.267s0.356-5.689 0.356-5.689c0 0 0-3.378-0.356-5.689zM12.444 21.333v-10.667l8.889 5.333-8.889 5.333z"></path>
</g>
<g id="as-pause">
<path d="M7 5H11V20H7V5ZM14 5H18V20H14V5Z" />
</g>
<g id="as-pip">
<path d="M23.632 5.854l-11.148 11.148 2.514 2.514 11.148-11.148 4.076 4.076v-10.667h-10.667z"></path>
<path d="M23.111 26.667h-17.778v-17.778h8.889v-3.556h-10.667c-0.981 0-1.778 0.796-1.778 1.778v21.333c0 0.981 0.796 1.778 1.778 1.778h21.333c0.981 0 1.778-0.796 1.778-1.778v-10.667h-3.556v8.889z"></path>
</g>
<g id="as-play">
<path d="M7.00002 5.47025C7.00002 5.09676 7.57955 4.87281 7.87872 5.07784L17.7971 12.1762C18.0676 12.3616 18.0676 12.7756 17.7971 12.961L7.8787 19.9222C7.57953 20.1272 7 19.9032 7 19.5297L7.00002 12.5686V5.47025Z" />
</g>
<g id="as-restart">
<path d="M17.244 2.133l1.244 11.378 3.733-3.733c3.378 3.378 3.378 9.067 0 12.444-1.6 1.778-3.911 2.667-6.222 2.667s-4.622-0.889-6.222-2.667c-3.378-3.378-3.378-9.067 0-12.444 1.067-1.067 2.489-1.956 4.089-2.311l-1.067-3.378c-2.133 0.533-4.089 1.6-5.689 3.2-4.8 4.8-4.8 12.622 0 17.6 2.311 2.311 5.511 3.556 8.711 3.556 3.378 0 6.4-1.244 8.711-3.556 4.8-4.8 4.8-12.622 0-17.6l3.911-3.911-11.2-1.244z"></path>
</g>
<g id="as-rewind">
<path d="M18 1.778l-18 14.222 18 14.222v-10.971l14 10.971v-28.444l-14 10.971z"></path>
</g>
<g id="as-settings">
<path d="M28.684 13.838c-2.316-0.58-3.415-3.232-2.187-5.278 0.572-0.953 0.4-1.774-0.167-2.34l-0.551-0.551c-0.565-0.565-1.387-0.738-2.34-0.167-2.048 1.228-4.7 0.13-5.278-2.187-0.268-1.079-0.972-1.538-1.772-1.538h-0.779c-0.8 0-1.502 0.459-1.772 1.538-0.58 2.316-3.232 3.415-5.278 2.187-0.953-0.572-1.776-0.4-2.341 0.165l-0.551 0.551c-0.565 0.565-0.738 1.388-0.165 2.341 1.228 2.048 0.13 4.7-2.187 5.278-1.076 0.268-1.538 0.971-1.538 1.772v0.779c0 0.8 0.459 1.502 1.538 1.772 2.316 0.58 3.415 3.232 2.187 5.278-0.572 0.953-0.4 1.774 0.167 2.34l0.551 0.551c0.567 0.567 1.39 0.738 2.34 0.167 2.048-1.228 4.7-0.13 5.278 2.187 0.268 1.079 0.972 1.538 1.772 1.538h0.779c0.8 0 1.502-0.459 1.772-1.538 0.58-2.316 3.232-3.415 5.278-2.187 0.951 0.571 1.772 0.4 2.34-0.167l0.551-0.551c0.565-0.565 0.738-1.388 0.167-2.34-1.228-2.048-0.13-4.7 2.187-5.278 1.079-0.268 1.538-0.972 1.538-1.772v-0.779c0-0.802-0.462-1.504-1.538-1.772v0zM16 21.333c-2.946 0-5.333-2.388-5.333-5.333s2.388-5.333 5.333-5.333c2.946 0 5.333 2.388 5.333 5.333s-2.388 5.333-5.333 5.333v0z"></path>
</g>
<g id="as-arrow-down">
<path d="M5.027 8.44l-2.36 2.36 13.2 13.2 13.2-13.2-2.36-2.36-10.84 10.84-10.84-10.84z"></path>
</g>
<g id="as-arrow-left">
<path d="M23.56 5.027l-2.36-2.36-13.2 13.2 13.2 13.2 2.36-2.36-10.84-10.84 10.84-10.84z"></path>
</g>
<g id="as-arrow-right-mini">
<path d="M11.453 22.12l6.107-6.12-6.107-6.12 1.88-1.88 8 8-8 8-1.88-1.88z"></path>
</g>
<g id="as-arrow-right-white">
<path fill="#000" d="M17.113 16.008l-4.845-4.846c-0.358-0.358-0.358-0.937 0-1.294s0.937-0.358 1.294 0l5.494 5.493c0.358 0.357 0.358 0.936 0 1.294l-5.493 5.492c-0.358 0.358-0.937 0.358-1.294 0s-0.358-0.937 0-1.294l4.844-4.845z"></path>
<path fill="#fff" d="M17.113 16.008l-4.845-4.846c-0.358-0.358-0.358-0.937 0-1.294s0.937-0.358 1.294 0l5.494 5.493c0.358 0.357 0.358 0.936 0 1.294l-5.493 5.492c-0.358 0.358-0.937 0.358-1.294 0s-0.358-0.937 0-1.294l4.844-4.845z"></path>
</g>
<g id="as-captions-off">
<path opacity="0.5" fill="#000" d="M4 8.001c0-0.615 0.669-1.334 1.33-1.334h21.339c0.71 0 1.33 0.719 1.33 1.334v15.983c0 0.682-0.649 1.349-1.345 1.349h-21.31c-0.647 0-1.345-0.667-1.345-1.349v-15.983zM9.135 11.435c-0.57 0-1.141 0.572-1.141 1.144v6.867c0 0.572 0.571 1.144 1.141 1.144h5.705v-2.289h-4.564v-4.578h4.564v-2.289h-5.705zM23.968 11.435h-5.705c-0.571 0-1.141 0.572-1.141 1.144v6.867c0 0.572 0.571 1.144 1.141 1.144h5.705v-9.155zM19.404 13.724v4.578h4.564v-4.578h-4.564z"></path>
</g>
<g id="as-captions-on">
<path d="M4 8.001c0-0.615 0.669-1.334 1.33-1.334h21.339c0.71 0 1.33 0.719 1.33 1.334v15.983c0 0.682-0.649 1.349-1.345 1.349h-21.31c-0.647 0-1.345-0.667-1.345-1.349v-15.983zM14.84 18.302h-4.564v-4.578h4.564v-2.289h-5.705c-0.571 0-1.141 0.572-1.141 1.144v6.866c0 0.572 0.57 1.144 1.141 1.144h5.705v-2.289zM23.968 20.59v-9.155h-5.705c-0.571 0-1.141 0.572-1.141 1.144v6.866c0 0.572 0.571 1.144 1.141 1.144h5.705zM19.404 13.724h4.564v4.578h-4.564v-4.578z"></path>
</g>
<g id="as-check">
<path d="M7.014 15.484l-3.014 3.123 7.734 8.060 16.266-16.854-3.036-3.146-13.23 13.708-4.72-4.891z"></path>
</g>
<g id="as-close">
<path d="M25.333 8.547l-1.88-1.88-7.453 7.453-7.453-7.453-1.88 1.88 7.453 7.453-7.453 7.453 1.88 1.88 7.453-7.453 7.453 7.453 1.88-1.88-7.453-7.453 7.453-7.453z"></path>
</g>
<g id="as-muted">
<path d="M5.787 3.907l-1.88 1.88 5.813 5.813-0.387 0.4h-5.333v8h5.333l6.667 6.667v-8.787l5.573 5.573c-0.867 0.653-1.84 1.173-2.907 1.48v2.747c1.787-0.4 3.427-1.227 4.813-2.333l2.733 2.733 1.88-1.88-22.307-22.293zM13.333 20.227l-2.893-2.893h-3.773v-2.667h3.773l1.173-1.173 1.72 1.72v5.013zM25.333 16c0 1.093-0.2 2.147-0.547 3.12l2.040 2.040c0.747-1.56 1.173-3.307 1.173-5.16 0-5.707-3.987-10.48-9.333-11.693v2.747c3.853 1.147 6.667 4.72 6.667 8.947zM16 5.333l-2.507 2.507 2.507 2.507v-5.013zM22 16c0-2.36-1.36-4.387-3.333-5.373v2.387l3.307 3.307c0.013-0.107 0.027-0.213 0.027-0.32z"></path>
</g>
<g id="as-volume">
<path d="M4 12v8h5.333l6.667 6.667v-21.333l-6.667 6.667h-5.333zM13.333 11.773v8.453l-2.893-2.893h-3.773v-2.667h3.773l2.893-2.893zM22 16c0-2.36-1.36-4.387-3.333-5.373v10.733c1.973-0.973 3.333-3 3.333-5.36zM18.667 4.307v2.747c3.853 1.147 6.667 4.72 6.667 8.947s-2.813 7.8-6.667 8.947v2.747c5.347-1.213 9.333-5.987 9.333-11.693s-3.987-10.48-9.333-11.693v0z"></path>
</g>
</defs>
</svg>
</div>
        

        </Host>
      );
    } 


    setupObserver() {
      // console.log('observer setup');
  
      const obs = new IntersectionObserver((entries, observerRef) => {
        // The callback is run when the visibility of one or more of the elements
        // being observed has changed. It's also called on page load.
        entries.forEach(async (entry) => {
          //`isIntersecting` will be `true` if any part of the element is currently visible
          if (entry.isIntersecting) {
            // We are assuming here that your Web Component is located in a file
            // named after it's tag name
            this.load();
            // Once we've observed this element come into view, we can safely remove
            // the observer since we won't need to import the WC code again
            observerRef.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '50px 0px 50px'
      });
      setTimeout(() => {
      const els1 = this.el.shadowRoot.querySelectorAll('.as-player-wrapper');
      els1.forEach((el) => {
        obs.observe(el);
      });
      }, 0);
      
  }
  

  getApiUrl (env?: string): string {
    let apiUrl = `https://apiv2.allstudio.live`;
    if(env === 'dev') {
      apiUrl = `${apiUrl}/dev`
    } else if(env === 'qa') {
      apiUrl = `${apiUrl}/qa`
    } else if(env === 'local') {
      apiUrl = `http://localhost:4011`;
    }
    return apiUrl;
  }
  
  getVideoUrl (vid: any): string {
    let finalUrl: string = vid.url;
    try {
      if (vid.isProcessed && vid.processedUrls['576p']) {
        finalUrl = vid.processedUrls['576p'];
      } 
    } catch(e) {
      finalUrl = vid.url;
    }
    // console.log('finalUrl', finalUrl);
    return finalUrl;
  }

  resetHeight(vidEl, s){
    // reset the body height to that of the inner browser
    // s.sh = window.innerHeight;
    // console.log('window inner height', s.sh);
    this.setPlayerHeight(vidEl, s);
  }

  setPlayerHeight(vidEl, s): void {
    const ch = s.el.getBoundingClientRect();
    // console.log('ch final', ch, s.fullscreen);
    if(s.w || s.h) {
      // console.log('defined final', s.w, s.h, s.fullscreen);
      if(s.mode === 'pinned' && s.fullscreen) {
        s.sh = window.innerHeight;
      }
      if(s.fullscreen) {
        s.h = `${s.sh}px`;
      }
      if(!s.w) {
        s.h = `100%`;
        s.w = `100%`;
      }
    } else {
      // const cw = this.el.clientHeight;
      let vw = ch.width;
      let vh = s.sh || ch.height;
      if(vw === 0 && vh === 0) {
        vw = s.sw || 0;
        vh = s.sh || 0;
      }
      if(this.mode === 'pinned' && this.fullscreen) {
        vh = window.innerHeight;
        vw = vh*9/16;
      }
      if(vw === 0 || !vw) {
        if(vh === 0) {
            vh = this.ch;
        }
        vw = vh*9/16;
      } else if (vh > 0 && vh/vw > 16/9 ) {
        const tw = vh*9/16
        if(tw > vw && !this.fullscreen) {
          vh = vw*16/9;
        } else if(vw === 0 && tw>0 && !this.fullscreen){
          vw = tw;
        }
      } else if (vh > 0 && vh/vw < 16/9 ) {
        const th = vw*16/9;
        if(th > vh) {
          vw = vh*9/16;
        } else if(vw === 0 && th>0){
          vh = th;
        }
      } else {
        if(vh === 0) {
          // console.log('setting video height', vidEl);
          if(!s.fullscreen) {
            vidEl.setAttribute('style', 'height:75vh;');
          } else {
            vidEl.setAttribute('style', 'height:100vh;');
          }
          vh = vidEl.getBoundingClientRect().height;
          vw = vidEl.getBoundingClientRect().width;
        } else {
          if(vh < vw && vh > 100) {
            vw = vh*9/16;
          } else {
            vh = vw*16/9;
          }
        }
      }
      // if(vh > ch.height && ch.height> 100) {
      //   vh = ch.height;
      //   vw = vh*9/16;
      // }

      if(vw >= 576) {
        if(vh > 1024) {
          vw = 576;
          vh = vw*16/9;
        } else {
          vh = window.innerHeight;
          vw = vh*9/16;
        }
      }

      // console.log('vw final', vw);
      s.w = `${Math.round(vw)}px`;
      s.h = `${Math.round(vh)}px`;
      // }
    }


    setTimeout(() => {
      if(s.fullscreen) {
        const flw: any = s.el.shadowRoot.querySelector('.flexWrapper');
        // console.log(flw);
        if(flw) {
          flw.style.maxHeight = window.innerHeight+'px';
        }
      }
    }, 100);
    // console.log('final height', s.w, s.h, this.fullscreen);
  }

  hideElement(cl: string, s = this) {
    s.el.shadowRoot.querySelector(`.${cl}`)?.setAttribute('hidden', 'true');
  }

  showElement(cl: string, s = this) {
    s.el.shadowRoot.querySelector(`.${cl}`)?.removeAttribute('hidden');
  }

  enablePip() {
    if(window?.innerWidth > 768 && this.ch < 215) {
      this.w = `${Math.round(this.ch*1.5*9/16)}px`;
      this.h = `${this.ch*1.5}px`;
    } else {
      this.w = `${Math.round(this.ch*9/16)}px`;
      this.h = `${this.ch}px`;
    }
    this.autoplay = true;
    this.showheader = true;
    this.showfootertitle = false;
    this.showheadertitle = false;
    this.showfooterplay = true;
  }

  pipFullScreen(vidEl, s) {
   // console.log('full screen pip');
    s.w = null;
    s.h = null;
    s.fullscreen = true;
    s.setPlayerHeight(vidEl, s);
    // console.log(this.h);
    s.showheadertitle = true;
    this.showElement('headerVideoTitle');
    s.showfooterplay = false;
    this.hideElement('footerPlay');
    this.hideElement('fullplayerclick');
    this.hideElement('closePipControl');
    this.showElement('enterPipControl');
    // s.w = '100%';
    // s.h = '100vh';
    s.isMute = false;
    s.player.muted = false;
    if(s.fullscreen || s.variant === 'chip') {
      s.showproductcard = true;
    }
    // s.setupPlyr();

    s.trackEvent('full_screen', {
      category: 'floating_player',
      mute: s.isMute,
      playing_time: s.playingTime,
      loop_count: s.loopCount,
    });

    setTimeout(()=> {
      s.isPlaying = s.player.playing;

      if(!s.isPlaying && (s.autoplay || s.mode === 'pinned')) {
        s.player.play();
        s.isPlaying = true;
      }
    }, 50);

    // s.trackEvent('view', {
    //   category: 'fullscreen_player',
    //   mute: s.isMute,
    //   playing_time: s.playingTime,
    //   loop_count: s.loopCount,
    //   ...s.getCtaAttributes(s),
    // });

  }

  getCtaAttributes(s) {
    if (s.fullscreen) {
      return {
        cta_type: s.video?.shoppableType,
        cta_title: s.video?.shoppableData?.ctaType,
        products_count: (s.video?.shoppableType === 'addtocart') ? 1 : 0, 
        loop_count: this.loopCount,
        playingTime: this.playingTime,
        platform: this.platform,
        duration: s.video?.duration,
      };
    } else {
      return {
        loop_count: this.loopCount,
        playingTime: this.playingTime,
        platform: this.platform,
        duration: s.video?.duration,
      };
    }
  }

  openCart() {
    var cartel: any = document.querySelector('a[href="/cart"]');
    cartel.click();
  }

  async addShopifyItem() {
    this.addToCartLoading = true;
    this.trackEvent('addtocart_click', {
      ...this.getCtaAttributes(this),
      category: 'fullscreen_player',
      playing_time: this.playingTime,
      loop_count: this.loopCount,
      mute: this.player.muted,
      playing: this.isPlaying,
      addtocart_id: this.shopifyVariantId,
      productid: this.shopifyProduct.product.id,
    });
    const result = await fetch("/cart/add.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify({
            id: this.shopifyVariantId,
            quantity: this.shopifyQty,
        })
    });
    this.addToCartLoading = false;
    if(result.status === 200) {
      this.addedToCart = true;
      this.trackEvent('addtocart_success', {
        ...this.getCtaAttributes(this),
        category: 'fullscreen_player',
        playing_time: this.playingTime,
        loop_count: this.loopCount,
        mute: this.player.muted,
        playing: this.isPlaying,
        addtocart_id: this.shopifyVariantId,
        productid: this.shopifyProduct.product.id,
      });
      const cart = await result.json();
      document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: true,
      }));
document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
        bubbles: true,
        detail: {
          cart,
        }
      }));
      if(!result.redirected) {
        var s = this;
        s?.pause();
        setTimeout(function() {
          s.openCart();
          s.enterPipClick(false);
        }, 600);
      }
      return cart;
    } else {
      this.trackEvent('addtocart_failure', {
        ...this.getCtaAttributes(this),
        category: 'fullscreen_player',
        playing_time: this.playingTime,
        loop_count: this.loopCount,
        mute: this.player.muted,
        playing: this.isPlaying,
        addtocart_id: this.shopifyVariantId,
        productid: this.shopifyProduct.product.id,
      });
      return false;
    }
  }

  async onShopifyProductPage() {
    const w: any = window;
    const path = w.location.pathname;
    // The pathname most likely looks like /collections/something/products/product-handle
    const potentialHandle = path.substring(path.lastIndexOf("/") + 1);
    if(w?.meta && w?.meta?.product?.id) {
      // console.log('returning p from meta');
      this.shopifyProduct = w.meta;
      this.shopifyVariantId = this.shopifyProduct?.product?.variants[0].id || null;
      return this.shopifyProduct;
    }
    const result = await fetch(`/products/${potentialHandle}.json`, {
        method: "GET",
        headers: {
            "Accept": "application/json"
        }
    });

    if (result.status === 200) {
      this.shopifyProduct = await result.json();
      this.shopifyVariantId = this.shopifyProduct?.product?.variants[0].id || null;
      return this.shopifyProduct;
    } else {
      return false;
    }
  }

  getPlayerCategory() {
    if (this.fullscreen && this.mode === 'pinned') {
      return 'fullscreen_player';
    }
    return this.widget;
  }

  autoPause() {
    if (this.widget === 'carousel_player' || this.widget === 'carousel_player_fullscreen') {
      return false;
    }
    return true;
  }

  widgetPlayClick(s) {
    // console.log('widget play click', s.widget);
    s.playclick();

    s.trackEvent('full_screen', {
      category: s.getPlayerCategory(),
      mute: s.player.muted,
      playing_time: s.playingTime,
      loop_count: s.loopCount,
    });
  
    // s.trackEvent('view', {
    //   category: `${s.widget}_fullscreen`,
    //   mute: s.player.muted,
    //   playing_time: s.playingTime,
    //   loop_count: s.loopCount,
    //   ...s.getCtaAttributes(s),
    // });

  }

  setVideo(finalvideo) {
    if(finalvideo?.width/finalvideo?.height > 9/16) {
      this.cover = false;
    }

    if(finalvideo?.channel?.primaryColor?.hex) {
      var style = document.createElement( 'style' )
      style.innerHTML = `.playerWrapper { --asplayer-btn-color: ${finalvideo.channel.primaryColor.hex}; --asplayer-ch: ${this.ch}px; }`;
      if(this.ch <= 210) {
        style.innerHTML = `${style.innerHTML}  @media (min-width: 768px) { .playerWrapper { --asplayer-ch: ${this.ch*1.5}px; } }`;
      }
      this.el.shadowRoot.appendChild( style );
    }

    if(finalvideo?.channel?.forceMute) {
      this.forcemute = true;
      this.isMute = true;
    }

    if(this.fullscreen && !this.forcemute) {
      this.isMute = false;
    }

    if(this.forcemute) {
      this.isMute = true;
    }

    if(this.platform === 'shopify' && this.shopify) {
      if(finalvideo?.shoppableType === 'addtocart' && 
      finalvideo.shoppableData?.productId !== this.shopifyProduct.product.id.toString()) {
        // console.log('product id doesn\'t match');
        return false;
      }
    }

    this.video = finalvideo;
    if(finalvideo) {
      var vidEl = this.el.shadowRoot.querySelector('.as-player-wrapper');
      const s = this;

      if(!this.fullscreen && this.playclick && this.mode!='pinned') {
        this.playControlClick = () => this.widgetPlayClick(s);
      }


      if(this.fullscreen) {
        this.playControlClick = () => {
          if(!this.isPlaying) {
            this.play();
          }
          this.isMute = !this.isMute;
          this.muted(this.isMute);
        }
      }

      //pip
      this.closePipClick = () => {
        s.pause();
        s.hidden = true;
        s.trackEvent('closed', {
          category: 'floating_player',
          mute: this.isMute,
          playing_time: this.playingTime,
          loop_count: this.loopCount,
        });
      }

      if(this.mode === 'pinned') {
        this.playControlClick = () => this.pipFullScreen(vidEl, s);
        this.playclick = () => this.playControlClick();
      }
      this.openFullScreen = () => {
        this.hideElement('openFsControl')
        this.showElement('closeFsControl')
        s.pipFullScreen(vidEl, s);
      }
      this.closeFullScreen = () => {
        this.hideElement('closeFsControl')
        this.showElement('openFsControl')
        s.w = null;
        s.h = null;
        this.fullscreen = false;
        s.setPlayerHeight(vidEl, s);
      };
      

      this.enterPipClick = (clicked = true, click_type = 'icon') => {
        // console.log('enter pip click');
        const overlay = this.productoverlay ? this.productoverlay : this.el.shadowRoot.querySelector('as-product-overlay');
        overlay?.close();
        this.showElement('fullplayerclick');
        this.isMute = true;
        this.muted(true);
        if(this.mode === 'pinned') {
          this.showElement('footerPlay');
          this.hideElement('headerVideoTitle');
          this.hideElement('footerVideoTitle');
          this.showElement('closePipControl');
          this.hideElement('enterPipControl');
        }
        if(!s.handlerPipMode) {
          s.fullscreen = false;
          s.enablePip();
        } else {
          s.pause();
          s.piphandler();
        }
        if(clicked) {
          s.trackEvent('closed_click', {
            click_type,
            category: s.getPlayerCategory(),
            mute: s.isMute,
            playing_time: s.playingTime,
            loop_count: s.loopCount,
            ...s.getCtaAttributes(s)
          })
        }
      }

      this.backdropClick = () => {
        // console.log('back drop click');

        if(this.mode === 'pinned') {
          this.enterPipClick(true, 'backdrop');
        } else {
          this.fullscreen = false;
        }
      }

      this.loading = false;
      this.video = finalvideo;

      // lozad

      if(this.mode === 'pinned' || this.widget === 'storyblok' || this.preload) {
        this.setupObserver();
      }
      // console.log(this.playControlClick);
    }
  }



  setupPlyr() {
    if(this.plyrloaded) {
      return;
    }
    try {
    const nel: any = this.el.shadowRoot.querySelector('#player');

    if(nel === undefined || !nel) {
      setTimeout(() => this.setupPlyr(), 200);
      return;
    }

    nel.setAttribute('poster', nel.getAttribute('data-poster'));

    for (var source in nel.children) {
      var videoSource = nel.children[source];
      if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
        videoSource.src = videoSource.dataset.src;
      }
    }

    let controls = ``;

    const videoTitle = (c) => `<div class="videoTitle ${c}VideoTitle" ><span class="videoTitleText">${this.video.title}</span></div>`;
    const hvideoTitle = (c) => `<div class="videoTitle ${c}VideoTitle" hidden ><span class="videoTitleText">${this.video.title}</span></div>`;

    if(this.showheader) {
      const headerVideoTitle =this.showheadertitle ? videoTitle('header'): hvideoTitle('header');

      /* <button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
            <svg class="icon--pressed" role="presentation" viewBox="0 0 28 28"><use xlink:href="#as-pause"></use></svg>
            <svg class="icon--not-pressed" role="presentation" viewBox="0 0 28 28"><use xlink:href="#as-play"></use></svg>
            <span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
            <span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
        </button> */

        const closeIcon = `<svg class="icon" role="presentation" viewBox="0 0 30 30"><use xlink:href="#as-close"></use></svg>`

        const openIcon = `<svg class="icon" role="presentation" viewBox="0 0 32 32"><use xlink:href="#as-enter-fullscreen"></use></svg>`;

        let fsControl = '';

        if(!this.fullscreen && this.mode !== 'pinned') { // storyblok enable open full screen action
          fsControl = `<button type="button" class="plyr__control openFsControl" aria-label="Close">${openIcon}</button>
          <button type="button" hidden class="plyr__control closeFsControl" aria-label="Close">${closeIcon}</button>`;
        }
        if(this.fullscreen && (this.mode !=='pinned') && !this.handlerPipMode) { // storyblock full screen mode
          fsControl = `<button type="button" class="plyr__control closeFsControl" aria-label="Close">${closeIcon}</button>
          <button type="button" hidden class="plyr__control openFsControl" aria-label="Close">${openIcon}</button>`
        }
        if(this.mode ==='pinned' && !this.fullscreen) { // pinned and not fullscreen
          fsControl = `<button type="button" class="plyr__control closePipControl" aria-label="Close">${closeIcon}</button>
          <button type="button" class="plyr__control enterPipControl" hidden aria-label="Close">${closeIcon}</button>`
        }
        if((this.mode ==='pinned' || this.handlerPipMode) && this.fullscreen) { // pinned and fullscreen
          fsControl = `<button type="button" class="plyr__control enterPipControl" aria-label="Close">${closeIcon}</button>
          <button type="button" class="plyr__control closePipControl" hidden aria-label="Close">${closeIcon}</button>`
        }

      controls = `<div class="plyr__controls">
        ${headerVideoTitle}
        <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
            <svg class="icon--pressed" role="presentation" viewBox="0 0 32 32"><use xlink:href="#as-muted"></use></svg>
            <svg class="icon--not-pressed" role="presentation" viewBox="0 0 32 32"><use xlink:href="#as-volume"></use></svg>
        </button>
        ${fsControl}
    </div><div class="topPlayerShow"></div>${controls}`
    }

    if(this.showfootertitle || this.showfooterplay) {
      const footerVideoTitle =this.showfootertitle ? videoTitle('footer'): hvideoTitle('footer');
      const footerPlay = this.showfooterplay ? `<button type="button" class="plyr__control footerPlay" aria-label="Play, {title}" data-plyr="play">
      <svg class="icon--pressed" role="presentation" viewBox="0 0 24 24"><use xlink:href="#as-pause"></use></svg>
      <svg class="icon--not-pressed" role="presentation" viewBox="0 0 24 24"><use xlink:href="#as-play"></use></svg>
  </button>` : `<button type="button" class="plyr__control footerPlay" hidden aria-label="Play, {title}" data-plyr="play">
  <svg class="icon--pressed" role="presentation" viewBox="0 0 24 24"><use xlink:href="#as-pause"></use></svg>
  <svg class="icon--not-pressed" role="presentation" viewBox="0 0 24 24"><use xlink:href="#as-play"></use></svg>
</button>`;
      controls = `${controls}
      <div class="plyr__controls footercontrols">
       ${footerVideoTitle}
       ${footerPlay}
      </div>
      `
    }


  if (this.playclick && !this.fullscreen) {
    controls = `<div class="fullplayerclick">
    <div style="height: ${this.h}"
    ></div></div>${controls}`
  }

  controls = `<div class="bottomPlayerShow"></div>
${controls}
<div class="plyr__progress">
<input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
<progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
<span role="tooltip" class="plyr__tooltip">00:00</span>
</div>`;

    
    // Setup the player
    // console.log('setting up plyr');
      this.player = new Plyr(nel, {
        autoplay: false,
        autopause: false,
        muted: (this.forcemute !== null && this.forcemute !== undefined) ? this.forcemute : this.isMute,
        loop: { active: this.loop },
        disableContextMenu: true,
        hideControls: false,
        resetOnEnd: true,
        // ratio:`${this.w ? this.w.replace('px', '') : 9}:${this.h ? this.h.replace('px', '') : 16}`,
        storage: { enabled: true, key: 'allstudio-plyr' },
        mediaMetadata: { title: this.video.title },
        displayDuration: false,
        loadSprite: false,
        controls,
        fullscreen: {enabled: false },
        tooltips: { controls: false, seek: false },
      });
      // this.player.autoplay = this.autoplay;
      this.plyrloaded = true;
      this.player.muted = (this.forcemute !== null && this.forcemute !== undefined) ? this.forcemute : this.isMute;
      // this.player.on('controlsshown', this.onControlsShown.bind(this));
      this.player.on('loadstart', this.onVmLoadStart.bind(this));
      this.player.on('canplay', this.onPlaybackReady.bind(this));
      this.player.on('ready', this.onVmReady.bind(this));
      this.player.on('timeupdate', this.onCurrentTimeChange.bind(this));
      this.player.on('playing', this.onPlayingChange.bind(this));
      this.player.on('volumechange',this.onMutedChange.bind(this));
      this.player.on('suspend', this.onPlaySuspend.bind(this));
    } catch(e) {
      this.plyrloaded = false;
      console.log('plyr setup err', e.message);
      setTimeout(this.setupPlyr, 200);
    }
  }

  private onPlaySuspend() {
    console.log('play suspend');
    this.playsuspend = true;
  }

  private onPlaybackStarted(s) {
    s.loopCount += 1;
    // console.log('playback started', s.loopCount);
    s.trackEvent('video_view', {
      category: s.getPlayerCategory(),
      mute: s.isMute,
      loop_count: s.loopCount,
      ...s.getCtaAttributes(s),
    });
    if(s.loopCount > 10) {
      s.pause();
    } else {
      if(s.autoplay && !s.player.playing && !s.playsuspend) {
        s.play();
      }
    }

  }


  private onPlaybackReady() {
   // console.log('player ready', this.mode);
    this.playerready = true;

    var s= this;

    if(s.autoplay && !s.playsuspend) {
      s.play();
      // this.trackEvent('autoplay', {
      //   mute: this.isMute,
      //   loopCount: this.loopCount,
      // });
    }

    setTimeout(()=> {
      s.isPlaying = s.player.playing;
      if(!s.isPlaying && (s.autoplay || s.mode === 'pinned') && !s.playsuspend) {
        // console.log('not playing');
        this.play();
        s.isPlaying = true;
      }
    }, 0);
  }

  private onVmReady() {
   // console.log('vm ready', this.mode);

    if(this.autoplay) {
      setTimeout(() => {
        if(!this.player.playing && !this.playsuspend) {
          this.playerready = true;
          this.play();
          // this.trackEvent('autoplay', {
          //   mute: this.isMute,
          //   loopCount: this.loopCount,
          // });
        }
      }, 500);
    } else {
      setTimeout(() => {
          this.playerready = true;
      }, 200);
    }

    this.el.shadowRoot.querySelector('.fullplayerclick')?.addEventListener('click', this.playclick, {
      passive: true,
    });
    this.el.shadowRoot.querySelector('.closeFsControl')?.addEventListener('click', this.closeFullScreen, {
      passive: true,
    });
    this.el.shadowRoot.querySelector('.openFsControl')?.addEventListener('click', this.openFullScreen, {
      passive: true,
    });
    this.el.shadowRoot.querySelector('.closePipControl')?.addEventListener('click', this.closePipClick, {
      passive: true,
    });
    this.el.shadowRoot.querySelector('.enterPipControl')?.addEventListener('click', this.enterPipClick, {
      passive: true,
    });
    // this.playerready = true;

    // this.trackEvent('impression', {
    //   mute: this.isMute,
    //   loopCount: this.loopCount,
    // });
  }

  private onVmLoadStart() {
    // console.log('vm load start');
  }

  private onPlayingChange() {
    // console.log('playing changed', this.player.playing);
    this.isPlaying = this.player.playing;
    const vel: any = this.el.shadowRoot.querySelector('video');
    const velplaying = !!(vel.currentTime > 0 && !vel.paused && !vel.ended && vel.readyState > 2);
    if(!this.isPlaying) {
      this.isPlaying = velplaying;
    }
    // this.trackEvent(this.isPlaying ? 'play' : 'pause', {
    //   category: this.getPlayerCategory(),
    //   mute: this.isMute,
    //   loopCount: this.loopCount,
    //   ...this.getCtaAttributes(this),
    // });
  }

  private onMutedChange(event: CustomEvent<any>) {
    // console.log('mute changed', event.detail.plyr.muted, this.mutehandler);
    this.isMute = event.detail.plyr.muted;
    if(this.mutehandler) {
      this.mutehandler(this.isMute);
    }
    // this.trackEvent(this.isMute ? 'mute' : 'unmute', {
    //   category: this.getPlayerCategory(),
    //   mute: this.isMute,
    //   loopCount: this.loopCount,
    //   ...this.getCtaAttributes(this),
    // });
  }

  private onCurrentTimeChange(event: any) {
    this.playingTime = event.detail.plyr.currentTime;
    // console.log('time change', this.playingTime, this.startTime, this.loopCount);
 
    // const watchTime = this.playingTime + this.loopCount * this.video.duration;
    if(this.loopCount === 0) {
      // this.trackEvent('engaged_video')
      if(this.playingTime - this.startTime >= 1) {
        const seconds = Math.round(this.playingTime);

        if(seconds === 3) {
          this.trackEvent('video_view', {
            category: this.getPlayerCategory(),
            mute: this.isMute,
            seconds,
            ...this.getCtaAttributes(this),
          });

                  
          this.trackEvent('played_second', {
            category: this.getPlayerCategory(),
            mute: this.isMute,
            seconds,
            ...this.getCtaAttributes(this),
          });
        }


        if(seconds === Math.round(this.video.duration*0.25)) {
          this.trackEvent('played_one_fourth', {
            category: this.getPlayerCategory(),
            mute: this.isMute,
            seconds,
            ...this.getCtaAttributes(this),
          });
        }

        if(seconds === Math.round(this.video.duration/3)) {
          this.trackEvent('played_one_third', {
            category: this.getPlayerCategory(),
            mute: this.isMute,
            seconds,
            ...this.getCtaAttributes(this),
          });
        }

        if(seconds === Math.round(this.video.duration*0.5)) {
          this.trackEvent('played_half', {
            category: this.getPlayerCategory(),
            mute: this.isMute,
            seconds,
            ...this.getCtaAttributes(this),
          });
        }

        if(seconds === Math.round(this.video.duration*0.75)) {
          this.trackEvent('played_75percent', {
            category: this.getPlayerCategory(),
            mute: this.isMute,
            seconds,
            ...this.getCtaAttributes(this),
          });
        }
        
        this.startTime = seconds;
      }
    }

    if(this.playingTime === 0) {
      if(this.loopCount === 0) {
        this.trackEvent('played_full', {
          category: this.getPlayerCategory(),
          mute: this.isMute,
          seconds: this.video.duration,
          ...this.getCtaAttributes(this),
        });
      }
      this.onPlaybackStarted(this);
    }
  }

  setJitsu(s) {
    jitsu.set({
      channelid : s.video.channelId,
      videoid: s.video.id,
      duration: s.video.duration,
      category: s.widget,
      env: s.env === '' ? 'live' : s.env,
      appid: 'allstudio',
      accountid: s.video?.channel?.accountId,
      playlistid: s.playlistId,
      index: s.index,
      type: 'video',
      typeId: s.video.id,
      photoid: null,
    });

    // posthog.group('accountid', `${s.env === 'live' || s.env === '' ? '': `${s.env}_`}${s.video?.channel?.accountId}`, {
    //   env: s.env,
    //   channelid: s.video.channelId,
    //   channel: s.video?.channel?.title,
    // });
    try {
    // posthog.register_once({
    //   channelid : s.video.channelId,
    //   videoid: s.video.id,
    //   duration: s.video.duration,
    //   category: s.widget,
    //   env: s.env === '' ? 'live' : s.env,
    //   appid: 'allstudio',
    //   accountid: s.video?.channel?.accountId,
    //   playlistid: s.playlistId,
    //   index: s.index,
    //   type: 'video',
    //   typeId: s.video.id,
    //   photoid: null,
    // });
    } catch(e) {
      
    }

  }

  trackEvent(name, data, s = null) {
    if(!s) {
      s = this;
    } else {
      s.setJitsu(s);
    }
    if(s.tk || s.tk === undefined) {
      // console.log('tracking event', name, data);
      try {
        jitsu.track(name, data);
        if(!name.includes('played_')) {
          // posthog.capture(name, data);
        }
      } catch(e) {
        // console.log('jitsu tracking error', e);
      }
    }
  }

}

// const liftP = func => (...args) =>
//   Promise.all(args).then(values => func(...values))

// const getVideo = (video) => video
// const getVideoL = liftP(getVideo);
